import React, {useContext, useEffect, useState} from "react";
import styles from './header.module.css'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faChevronDown, faLink} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import axiosInstance from "../../AxiosInstance";
import MyContext from "../../Context";
import Modal from "../modal/modal";
import {LogoInput, TextInput} from "../input/inputs";
import {useTranslation} from "react-i18next";
import i18n from "../../i18n";

export default function Header({sidebarIndex}) {
    const {t} = useTranslation();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [ppOpen, setPPOpen] = useState(false);
    const {user} = useContext(MyContext);
    const [form, setForm] = useState(user || {});
    const [showError, setShowError] = useState(false);

    const project = JSON.parse(localStorage.getItem('project'));

    useEffect(() => {
        setForm(user);
    }, [user]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        let screenWidth = window.innerWidth;
        if(screenWidth < 750) {
            setSidebarOpen(false);
        } else {
            setSidebarOpen(true);
        }
    }, [windowWidth]);

    const logout = () => {
        localStorage.clear();
        axiosInstance.defaults.headers.common['Authorization'] = null;
        window.location.replace('/login');
    }

    const changePP = () => {
        if(form?.password !== form?.password_again) {
            setShowError(true);
            return;
        }

        let formData = new FormData();
        for(const key in form) {
            formData.append(key, form[key]);
        }

        axiosInstance.post('change_pp/', formData).then((res) => {
            if (form?.language && form.language !== i18n.language) {
                localStorage.setItem('user_language', form.language);
                i18n.changeLanguage(form.language);
            }
            window.location.reload();
        });
    }

    const languageOptions = [
        {value: 'en', label: 'English'},
        {value: 'es', label: 'Español'},
        {value: 'fr', label: 'Français'},
    ];

    return(
        <div>
            <Modal name={t('header.editProfile')} buttonName={t('common.save')} onClick={changePP} show={ppOpen} setter={setPPOpen}>
                <LogoInput name={'pp'} form={form} setForm={setForm} current={user?.profile_picture?.image} circular={true}/>

                <TextInput name={t('header.username')} internalName={'username'} form={form} setForm={setForm}/>
                <TextInput name={t('header.firstName')} internalName={'first_name'} form={form} setForm={setForm}/>
                <TextInput name={t('header.lastName')} internalName={'last_name'} form={form} setForm={setForm}/>
                <TextInput name={t('header.password')} internalName={'password'} form={form} setForm={setForm}/>
                <TextInput name={t('header.passwordRepeat')} internalName={'password_again'} form={form} setForm={setForm}/>

                <div className={'form-group mb-3'}>
                    <div className={'mb-1'} style={{fontWeight: '500', fontSize: '0.875rem'}}>{t('header.language')}</div>
                    <select
                        className={'form-control rounded-2'}
                        value={form?.language || 'en'}
                        onChange={(e) => setForm({...form, language: e.target.value})}
                        style={{border: '1px solid #dee2e6', padding: '0.375rem 0.75rem'}}
                    >
                        {languageOptions.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </select>
                </div>

                {form?.password !== form?.password_again &&
                    <div className={'mb-3'} style={{color: "red"}}>{t('header.passwordMismatch')}</div>
                }

                {showError &&
                    <div className={`${styles.error} px-3 py-2`}>
                        <img alt={'alert'} src={'/alert.png'} height={'24px'}/>
                        <div className={'ps-2'}>{t('header.checkFields')}</div>
                    </div>
                }
            </Modal>
            <nav className={`navbar navbar-expand-lg navbar-light py-2 ${styles.header}`}>
                <div className={`${styles.sidebar} ms-3`} role={'button'} onClick={() => setSidebarOpen(!sidebarOpen)}>
                    <img src={'/header/sidebar.png'} height={'32px'} alt={'sidebar_button'}/>
                </div>
                <div className={'d-flex align-items-center'}>
                    <img alt={'building'} src={'/sidebar/building.png'} height={'24px'} className={'pe-2 ps-3'}/>
                    <div style={{fontWeight: "600", fontSize: "large"}}>{project && project.name}</div>
                </div>
                <div role={'button'} className={`${styles.userMenu}`} onClick={() => setMenuOpen(!menuOpen)}>
                    <img src={(user?.profile_picture && user?.profile_picture?.image) ? user.profile_picture.image : '/default_pp.png'} style={{borderRadius: '50%', objectFit: 'cover'}} height={'40px'} width={'40px'} alt={'profile'}/>
                    <div style={{textAlign: "left"}} className={`mx-2 ${styles.menuText}`}>
                        <div style={{fontSize: "medium"}}><b>{(user?.first_name || user?.last_name) ? [user.first_name, user.last_name].filter(Boolean).join(' ') : user?.username}</b></div>
                        <div style={{fontSize: "small"}}>{user?.role?.name || 'User'}</div>
                    </div>
                    <div
                        className={`${styles.chevronIcon} rounded-5 py-1 px-2`}
                    >
                        <FontAwesomeIcon icon={faChevronDown} size="1x" color="#94A3B8"/>
                    </div>

                    <div className={`${styles.dropdown} ${!menuOpen && styles.hide}`}>
                        <Link to={'/settings/users'} className={`${styles.dropdownItem}`}>{t('header.users')}</Link>
                        <div className={styles.dropdownItem} onClick={() => setPPOpen(true)}>{t('header.updateProfile')}</div>
                        <div onClick={() => logout()} className={`${styles.dropdownItem}`}>{t('header.logout')}</div>
                    </div>
                </div>
            </nav>

            {sidebarOpen && <Sidebar sidebarIndex={sidebarIndex} setShouldOpen={setSidebarOpen}/> }
        </div>
    )
}